(function () {
  'use strict';
  var R = (window.BYLILY && window.BYLILY.routes) || {};
  var S = (window.BYLILY && window.BYLILY.strings) || {};

  function container() { return document.getElementById('CartDrawerSection'); }

  function replaceDrawer(html) {
    var el = container();
    if (!el) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerSection');
    if (fresh) el.innerHTML = fresh.innerHTML;
    bindPolicy();
    updateBubble(doc);
  }

  function updateBubble(doc) {
    var count = doc ? doc.querySelector('[data-cart-count-value]') : null;
    var bubbles = document.querySelectorAll('[data-cart-count]');
    if (!count) return;
    bubbles.forEach(function (b) {
      b.textContent = count.textContent;
      b.classList.toggle('is-visible', parseInt(count.textContent, 10) > 0);
    });
  }

  function refresh(sections) {
    if (sections && sections['cart-drawer']) {
      replaceDrawer(sections['cart-drawer']);
      if (typeof window.openDrawer === 'function') window.openDrawer('CartDrawer');
      return Promise.resolve();
    }
    return fetch(R.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        replaceDrawer(html);
        if (typeof window.openDrawer === 'function') window.openDrawer('CartDrawer');
      });
  }

  document.addEventListener('cart:refresh', function (e) {
    refresh(e.detail && e.detail.sections);
  });

  function changeLine(line, quantity) {
    return fetch(R.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.sections && json.sections['cart-drawer']) {
          replaceDrawer(json.sections['cart-drawer']);
        } else {
          window.location.reload();
        }
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0);
      return;
    }
    var step = e.target.closest('[data-cart-qty]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-line'), step.getAttribute('data-cart-qty'));
    }
  });

  function bindPolicy() {
    document.querySelectorAll('[data-policy-form]').forEach(function (form) {
      var checkbox = form.querySelector('[data-policy-check]');
      var button = form.querySelector('[data-checkout-button]');
      var error = form.querySelector('[data-policy-error]');
      if (!checkbox || !button) return;
      function sync() {
        button.disabled = !checkbox.checked;
        button.setAttribute('aria-disabled', checkbox.checked ? 'false' : 'true');
        if (checkbox.checked && error) error.classList.remove('is-visible');
      }
      checkbox.addEventListener('change', sync);
      form.addEventListener('submit', function (ev) {
        if (!checkbox.checked) {
          ev.preventDefault();
          if (error) { error.textContent = S.policy_required; error.classList.add('is-visible'); }
        }
      });
      sync();
    });
  }

  document.addEventListener('DOMContentLoaded', bindPolicy);
  bindPolicy();
})();
